import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import React from "react";
import MaterialTextField from "../inputs/MaterialTextField";
import MaterialSelect from "../inputs/MaterialSelect";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";
import MaskedMaterialTextField from "../inputs/MaskedMaterialTextField";

function BillingAddressForm({ form, regionsByCountry, allCountries, handleCountryChanged, onSubmit }) {
    const { t } = useTranslation();
    return form ? <Grid container spacing={3} justifyContent={"center"} alignItems={"center"}>
        <Grid item xs={12} lg={7}>
            <MaterialTextField
                fullWidth
                margin="normal"
                field={form.$("billFirstName")}
                InputLabelProps={{
                    shrink: true,
                }}
            />
        </Grid>
        <Grid item xs={12} lg={7}>
            <MaterialTextField
                fullWidth
                margin="normal"
                field={form.$("billLastName")}
                InputLabelProps={{
                    shrink: true,
                }}
            />
        </Grid>
        <Grid item xs={12} lg={7}>
            <MaterialSelect
                fullWidth
                label="Language"
                margin="normal"
                labelAccessor={(x => x.countryName)}
                valueAccessor={(x => x.countryShortCode)}
                field={form.$("billCountry")}
                options={allCountries}
                onChange={handleCountryChanged} />
        </Grid>
        <Grid item xs={12} lg={7}>
            <MaterialTextField
                fullWidth
                margin="normal"
                field={form.$("billAddress")}
                InputLabelProps={{
                    shrink: true,
                }}
            />
        </Grid>
        <Grid item xs={12} lg={7}>
            <MaterialTextField
                fullWidth
                margin="normal"
                field={form.$("billCity")}
                InputLabelProps={{
                    shrink: true,
                }}
            />
        </Grid>
        <Grid item xs={12} lg={7}>
            {(form.$("billPostalCode").extra
                && form.$("billPostalCode").extra.mask)
                ? <MaskedMaterialTextField
                    margin="normal"
                    field={form.$("billPostalCode")}
                    InputLabelProps={{
                        shrink: true,
                    }} />
                : <MaterialTextField
                    fullWidth
                    margin="normal"
                    field={form.$("billPostalCode")}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            }
        </Grid>
        <Grid item xs={12} lg={7}>
            <MaterialSelect
                fullWidth
                label="Language"
                margin="normal"
                labelAccessor={(x => x.name)}
                valueAccessor={(x => x.shortCode)}
                field={form.$("billRegion")}
                options={regionsByCountry[form.$("billCountry").value] || []} />
        </Grid>
        {onSubmit && <Grid item xs={12} lg={7}>
            <Button onClick={onSubmit} fullWidth variant={"contained"}
                color="primary">{t("enrollment:continue")}</Button>

        </Grid>}
    </Grid> : null;
}

export default observer(BillingAddressForm);